import httpClient from './httpClient';

export const PROMOTION_BANNER_SET_ENDPOINT = '/backoffice/product-promotion-banner-sets';

export const getPromotionBannerSetsAPI = async (params) => httpClient.get(`${PROMOTION_BANNER_SET_ENDPOINT}`, { params });
export const getPromotionBannerSetAPI = (id) => httpClient.get(`${PROMOTION_BANNER_SET_ENDPOINT}/${id}`);
export const postPromotionBannerSetAPI = async (data) => httpClient.post(`${PROMOTION_BANNER_SET_ENDPOINT}`, data);
export const putPromotionBannerSetAPI = (id, params) => httpClient.put(`${PROMOTION_BANNER_SET_ENDPOINT}/${id}`, params);
export const deletePromotionBannerSetAPI = (id) => httpClient.delete(`${PROMOTION_BANNER_SET_ENDPOINT}/${id}`);
